<template>
  <div
    class="period"
    :class="{
      'period--error': startError || endError,
    }"
  >
    <div class="period__wrapper">
      <div
        class="period-calendar"
        :class="{
          'period-calendar--active': activeCalendar === 'start',
        }"
      >
        <div
          :class="{
            'period-calendar-input--required': startError,
          }"
          class="period-calendar-input"
        >
          <the-mask
            v-model="start.input"
            mask="##.##.####"
            class="period-calendar-input__field"
            type="text"
            placeholder="00.00.0000"
            :masked="true"
          />

          <div class="period-calendar-input__icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                stroke="#8E9CBB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
              <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
              <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
            </svg>
          </div>
        </div>

        <div v-if="startError || endError" class="period-calendar__error">
          <error-feedback v-if="startError" :text="startError.text"></error-feedback>
        </div>

        <div class="period-calendar__picker">
          <datepicker
            :inline="true"
            :language="ru"
            :full-month-name="true"
            :monday-first="true"
            :highlighted="{
              from: start.highlighted,
              to: end.highlighted,
            }"
            :open-date="startMonth"
            :value="start.selected"
            calendar-class="c-input-container-calendar c-input-container-calendar_period"
            @changedMonth="changedStartMonth"
            @selected="periodSelectStartDay"
          />
        </div>
      </div>

      <div
        class="period-calendar"
        :class="{
          'period-calendar--active': activeCalendar === 'end',
        }"
      >
        <div
          :class="{
            'period-calendar-input--required': endError,
          }"
          class="period-calendar-input"
        >
          <the-mask
            v-model="end.input"
            mask="##.##.####"
            class="period-calendar-input__field"
            type="text"
            placeholder="00.00.0000"
            :masked="true"
          />

          <div class="period-calendar-input__icon">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
                stroke="#8E9CBB"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
              <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
              <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
              <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
            </svg>
          </div>
        </div>

        <div v-if="startError || endError" class="period-calendar__error">
          <error-feedback v-if="endError" :text="endError.text"></error-feedback>
        </div>

        <div class="period-calendar__picker">
          <datepicker
            :inline="true"
            :language="ru"
            :full-month-name="true"
            :monday-first="true"
            :highlighted="{
              from: start.highlighted,
              to: end.highlighted,
            }"
            :open-date="endMonth"
            :value="end.selected"
            calendar-class="c-input-container-calendar c-input-container-calendar_period"
            @changedMonth="changedEndMonth"
            @selected="periodSelectEndDay"
          />
        </div>
      </div>
    </div>

    <div class="period-switcher">
      <div
        class="period-switcher__item"
        :class="{
          'period-switcher__item--active': activeCalendar === 'start',
        }"
        @click="activeCalendar = 'start'"
      >
        <span>Начало периода</span>
      </div>

      <div
        class="period-switcher__item"
        :class="{
          'period-switcher__item--active': activeCalendar === 'end',
        }"
        @click="activeCalendar = 'end'"
      >
        <span>Конец периода</span>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import { TheMask, mask } from "vue-the-mask";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: {
    TheMask,
    Datepicker,
    ErrorFeedback,
  },
  directives: { mask },
  props: ["value", "required"],

  data() {
    return {
      ru,
      submitted: false,
      start: {
        input: "",
        selected: null,
        value: null,
        highlighted: null,
      },
      end: {
        input: "",
        selected: null,
        value: null,
        highlighted: null,
      },
      startMonth: null,
      endMonth: null,
      activeCalendar: "start",
    };
  },

  computed: {
    startError() {
      if (!this.submitted) return null;

      const date = this.start.highlighted;

      if (!date) {
        if (this.required)
          return {
            type: "required",
            text: "Обязательное поле",
          };
        return null;
      }

      if (!moment(date).isValid()) {
        return {
          type: "format",
          text: "Неверный формат",
        };
      }

      return null;
    },

    endError() {
      if (!this.submitted) return null;

      const date = this.end.highlighted;

      if (!date) {
        if (this.required)
          return {
            type: "required",
            text: "Обязательное поле",
          };
        return null;
      }

      if (!moment(date).isValid()) {
        return {
          type: "format",
          text: "Неверный формат",
        };
      }

      if (!this.startError) {
        const startDate = moment(this.start.highlighted);

        if (moment(date).isBefore(startDate)) {
          return {
            type: "period",
            text: "Указан некорректный период",
          };
        }
      }

      return null;
    },

    isValid() {
      return !(this.startError || this.endError);
    },
  },

  watch: {
    "start.input": function (value) {
      if (value && value.length === 10) {
        const startDate = moment(value, "DD.MM.YYYY");
        const date = startDate.toDate();
        this.start.highlighted = date;
        this.start.selected = date;

        if (this.end.selected) {
          if (moment(this.end.selected).isBefore(startDate)) {
            this.end.highlighted = null;
            this.end.selected = null;
            this.end.input = "";
          }
        }

        this.onUpdate();
      }
    },

    "end.input": function (value) {
      if (value && value.length === 10) {
        const endDate = moment(value, "DD.MM.YYYY");
        const date = endDate.toDate();
        this.end.highlighted = date;
        this.end.selected = date;

        if (this.start.selected) {
          if (moment(this.start.selected).isAfter(endDate)) {
            this.start.highlighted = null;
            this.start.selected = null;
            this.start.input = "";
          }
        }

        this.onUpdate();
      }
    },
  },

  mounted() {
    if (this.value) {
      if (this.value.start) {
        const date = moment(this.value.start, "DD.MM.YYYY");
        this.start.highlighted = date.toDate();
        this.start.selected = date.toDate();
        this.start.input = this.value.start;
      }

      if (this.value.end) {
        const date = moment(this.value.end, "DD.MM.YYYY");
        this.end.highlighted = date.toDate();
        this.end.selected = date.toDate();
        this.end.input = this.value.end;
      }

      let startMonth = moment().startOf("month");
      if (this.value.start) {
        startMonth = moment(this.value.start, "DD.MM.YYYY").startOf("month");
      }

      let endMonth = startMonth.clone().add(1, "months");
      if (this.value.end) {
        endMonth = moment(this.value.end, "DD.MM.YYYY").startOf("month");
      }

      this.startMonth = startMonth.toDate();
      this.endMonth = endMonth.toDate();

      if (endMonth.isSame(startMonth)) {
        this.endMonth = endMonth.add(1, "month").toDate();
      }

      this.$forceUpdate();
    } else {
      const today = moment().startOf("month");

      this.startMonth = moment(today).subtract(1, "month").toDate();
      this.endMonth = moment(today).toDate();
    }
  },

  methods: {
    onUpdate() {
      this.$nextTick(() => {
        this.$emit("input", {
          start: this.start.input,
          end: this.end.input,
        });

        this.$forceUpdate();
      });
    },

    validate() {
      this.submitted = true;

      this.$nextTick(() => {
        const intViewportWidth = window.innerWidth;
        if (intViewportWidth < 768) {
          if (this.startError) {
            this.activeCalendar = "start";
          } else if (this.endError) {
            this.activeCalendar = "end";
          }
        }
      });

      return this.isValid;
    },

    periodReset() {
      this.start.input = "";
      this.end.input = "";

      this.end.selected = null;
      this.start.selected = null;

      this.start.highlighted = null;
      this.end.highlighted = null;

      this.dateValue = "";

      setTimeout(() => {
        this.submitted = false;
      }, 300);
    },

    periodSelectStartDay(date) {
      this.periodSelectDay(date, "start");
    },

    periodSelectEndDay(date) {
      this.periodSelectDay(date, "end");
    },

    periodSelectDay(date) {
      const newDate = moment(date);
      let newStartDate = null;
      let newEndDate = null;

      // выбраны обе даты
      if (this.start.selected && this.end.selected) {
        const startDate = moment(this.start.selected);
        const endDate = moment(this.end.selected);

        // новая дата раньше выделенного периода
        if (newDate.isSameOrBefore(startDate)) {
          newStartDate = newDate;
          newEndDate = startDate;
        }
        // новая дата позже выделенного периода
        else if (newDate.isSameOrAfter(endDate)) {
          newStartDate = endDate;
          newEndDate = newDate;
        }
        // новая дата внутри выделенного периода
        else {
          newStartDate = newDate;
          newEndDate = null;
        }
      }
      // выбрана только одна дата
      else if (this.start.selected) {
        const startDate = moment(this.start.selected);

        if (startDate.isAfter(newDate)) {
          newStartDate = newDate;
          newEndDate = startDate;
        } else {
          newStartDate = startDate;
          newEndDate = newDate;
        }
      }
      // ни одна дата не выбрана
      else {
        newStartDate = newDate;
        newEndDate = null;
      }

      // Обновить календари
      if (newStartDate) {
        this.start.highlighted = newStartDate.toDate();
        this.start.selected = newStartDate.toDate();
        this.start.input = newStartDate.format("DD.MM.YYYY");
      } else {
        this.start.highlighted = null;
        this.start.input = "";
        this.start.selected = null;
      }

      if (newEndDate) {
        this.end.highlighted = newEndDate.toDate();
        this.end.selected = newEndDate.toDate();
        this.end.input = newEndDate.format("DD.MM.YYYY");
      } else {
        this.end.highlighted = null;
        this.end.input = "";
        this.end.selected = null;
      }

      this.onUpdate();
    },

    changedStartMonth(value) {
      if (moment(this.endMonth).isSameOrBefore(moment(value))) {
        this.endMonth = moment(value).add(1, "month").toDate();
      }
      this.$forceUpdate();
    },

    changedEndMonth(value) {
      if (moment(this.startMonth).isSameOrAfter(moment(value))) {
        this.startMonth = moment(value).subtract(1, "month").toDate();
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.period {
  &__wrapper {
    display: flex;

    @media (max-width: 767px) {
      margin: 0 -20px;
      padding: 20px 20px 0;
      position: relative;
      height: 320px;

      &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 12px;
        background: linear-gradient(0, #8e9cbb 0%, #ffffff 100%);
        opacity: 0.2;
        top: -12px;
        left: 0;
      }
    }
  }

  &--error {
    .period__wrapper {
      @media (max-width: 767px) {
        height: 340px;
      }
    }
  }

  &-switcher {
    display: none;

    @media (max-width: 767px) {
      display: flex;
      margin: 0 -20px;
      padding: 0 20px;
    }

    &__item {
      width: 100%;
      display: flex;
      align-items: center;
      font: {
        size: 13px;
        weight: 500;
      }
      color: $color-primary;

      span {
        position: relative;
        display: inline-block;
        line-height: 40px;

        &:before {
          position: absolute;
          content: "";
          height: 4px;
          width: 100%;
          background: $color-secondary;
          top: 40px;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
        }
      }

      &--active {
        color: $color-font;

        span {
          &:before {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }

  &-calendar {
    &__error {
      height: 20px;

      & /deep/ {
        .error-feedback {
          transform: translateY(4px);
        }
      }
    }
    &:first-child {
      margin-right: 23px;
      & /deep/ {
        .prev {
          &:before {
            background-position: center left 15px;
          }
        }
        .next {
          &:before {
            background-position: center left;
          }
        }
      }
    }

    &:last-child {
      & /deep/ {
        .prev {
          &:before {
            background-position: center left;
          }
        }

        .next {
          &:before {
            background-position: center left 15px;
          }
        }
      }
    }

    @media (max-width: 767px) {
      position: absolute;
      opacity: 0;
      visibility: hidden;
      transition: 0.2s;
      width: calc(100% - 40px);

      &:first-child {
        margin-right: 0;
      }

      &:first-child,
      &:last-child {
        & /deep/ {
          .prev {
            &:before {
              background-position: center left 10px;
            }
          }
          .next {
            &:before {
              background-position: center left 10px;
            }
          }
        }
      }

      &--active {
        opacity: 1;
        visibility: visible;
      }
    }

    &__picker {
      & /deep/ {
        .c-input-container-calendar {
          & > div {
            max-width: 238px;
            margin-left: auto;
            margin-right: auto;
          }
        }
        header {
          .next,
          .prev {
            visibility: visible;
          }
        }
      }

      @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        align-items: center;

        & /deep/ {
          .vdp-datepicker {
            .c-input-container-calendar {
              width: 275px !important;
              & > div {
                max-width: none;

                .cell.day {
                  width: 100% !important;
                }
              }
            }
          }
        }
      }
    }
    &-input {
      display: flex;
      width: 100%;
      border-bottom: 1px solid $color-border;

      &--required {
        border-bottom: 1px solid $color-error;
      }

      &__field {
        width: 100%;
        height: 30px;
        font-size: 15px;
        padding: 0 0 13px 0;
        border: none;

        &::placeholder {
          color: $color-label;
        }

        &:focus {
          outline: none;
        }
      }

      &__icon {
        margin-top: -4px;
      }
    }
  }

  @media screen and (max-width: 767px) {
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>
